import { analyticsTrackEvent } from '@core/utils/analytics';
import {
  HOME_TOUR_COMPLETED,
  HOME_TOUR_DISMISSED,
  HOME_TOUR_PROMPT_SHOWN,
  HOME_TOUR_SKIPPED,
  HOME_TOUR_STARTED,
  HOME_TOUR_STEP_VIEWED,
} from '@core/constants/analytics';
import type { TourSource } from '@app/shared/tour';

const ITEM_TYPE = 'HomeTour';

export type HomeTourSource = TourSource;

type TourStepProps = {
  stepId?: string;
  stepIndex?: number;
  totalSteps?: number;
  source?: TourSource;
};

export const trackHomeTourPromptShown = () => {
  analyticsTrackEvent(HOME_TOUR_PROMPT_SHOWN, { itemType: ITEM_TYPE });
};

export const trackHomeTourDismissed = () => {
  analyticsTrackEvent(HOME_TOUR_DISMISSED, { itemType: ITEM_TYPE });
};

export const trackHomeTourStarted = (source: HomeTourSource) => {
  analyticsTrackEvent(HOME_TOUR_STARTED, { itemType: ITEM_TYPE, source });
};

export const trackHomeTourStepViewed = ({
  stepId,
  stepIndex,
  totalSteps,
  source,
}: TourStepProps) => {
  analyticsTrackEvent(HOME_TOUR_STEP_VIEWED, {
    itemType: ITEM_TYPE,
    stepId,
    stepIndex,
    totalSteps,
    source,
  });
};

export const trackHomeTourCompleted = ({
  totalSteps,
  source,
}: TourStepProps) => {
  analyticsTrackEvent(HOME_TOUR_COMPLETED, {
    itemType: ITEM_TYPE,
    totalSteps,
    source,
  });
};

export const trackHomeTourSkipped = ({
  stepId,
  stepIndex,
  totalSteps,
  source,
}: TourStepProps) => {
  analyticsTrackEvent(HOME_TOUR_SKIPPED, {
    itemType: ITEM_TYPE,
    stepId,
    stepIndex,
    totalSteps,
    source,
  });
};
